import React from 'react';

const Stars = ({ fill = '' }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4545 5.19711L12.25 3.4106L14 2.59855L12.25 1.78651L11.4545 0L10.6591 1.78651L8.90909 2.59855L10.6591 3.4106L11.4545 5.19711ZM6.68182 5.52193L5.09091 1.94892L3.5 5.52193L0 7.14602L3.5 8.77012L5.09091 12.3431L6.68182 8.77012L10.1818 7.14602L6.68182 5.52193ZM11.4545 9.09494L10.6591 10.8814L8.90909 11.6935L10.6591 12.5055L11.4545 14.292L12.25 12.5055L14 11.6935L12.25 10.8814L11.4545 9.09494Z"
      fill={fill || "#F5B900"}
    />
  </svg>
);

export default Stars;
